// import Tab from '@mui/material/Tab';
// import Tabs from '@mui/material/Tabs';
import { getHeadings, getParsedFileContentBySlug, ProductFrontMatter, renderMarkdown } from '@prishapolicy/markdown';
import { mdxElements } from '@prishapolicy/shared/mdx-elements';
import { HeroBackground, productColorMapping, ProductMain, unslugify } from '@prishapolicy/shared/ui';
import {
  CallbackForm,
  engineeringfaqList,
  Faq,
  firefaqList,
  healthfaqList,
  liabilityfaqList,
  marinefaqList,
  motorfaqList,
  otherfaqList,
  ProductPageProps,
  ProductWriteUpContext,
  PRODUCT_WRITEUPS_PATH,
  TableOfContents,
  travelfaqList,
  UnderConstruction,
  useW3PurchaseFlow,
  WhyChooseUs,
  lifeFaqList,
  CyberInsuranceFaqList,
  ProfessionalIndemnityFaqList,
} from '@prishapolicy/w3/ui';
import fs from 'fs';
import { JSDOM } from 'jsdom';
import { GetStaticPaths } from 'next';
import { MDXRemote } from 'next-mdx-remote';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import { join } from 'path';
import { ParsedUrlQuery } from 'querystring';
import { Fragment, useRef } from 'react';
import { renderToString } from 'react-dom/server';
import ArrowRightSLineIcon from 'remixicon-react/ArrowRightSLineIcon';

const faqListMapping = {
  motor: motorfaqList,
  fire: firefaqList,
  health: healthfaqList,
  travel: travelfaqList,
  liability: liabilityfaqList,
  engineering: engineeringfaqList,
  marine: marinefaqList,
  other: otherfaqList,
  life: lifeFaqList,
  cyber: CyberInsuranceFaqList,
  professional: ProfessionalIndemnityFaqList,
};

interface SubProductProps extends ParsedUrlQuery {
  slug: string[];
}

// const MobileHeadingsView = (props: {
//   headings: ReturnType<typeof getHeadings>;
//   activeSection: string;
//   showMobileNav: boolean;
// }) => {
//   return (
//     <div
//       className={`lg:hidden ${
//         props.showMobileNav ? 'top-16 opacity-100' : 'top-0 opacity-0'
//       } fixed left-0 right-0 flex justify-center overflow-x-auto bg-white px-4 transition-all duration-300`}
//     >
//       <Tabs variant="scrollable" value={props.activeSection || false}>
//         {props.headings.map((heading, idx) => {
//           return (
//             <Tab
//               href={heading.link}
//               key={idx}
//               label={heading.text}
//               value={heading.link}
//               sx={{
//                 textTransform: 'none',
//                 '&.Mui-selected': {
//                   color: '#27378C',
//                   textDecoration: 'underline',
//                   textUnderlineOffset: '8px',
//                   fontWeight: 900,
//                 },
//               }}
//             />
//           );
//         })}
//       </Tabs>
//     </div>
//   );
// };

const ProductBreadcrumbs = ({
  items,
}: {
  items: {
    name: string;
    link?: string;
  }[];
}) => {
  return (
    <p className="text-body-3 flex items-center capitalize">
      {items.map((item, idx) => {
        const computedClassName = `flex font-medium ${item.link && 'cursor-pointer'}`;
        return (
          <Fragment key={idx}>
            {item.link ? (
              <Link href={item.link} className={computedClassName}>
                {item.name}
              </Link>
            ) : (
              <span className={computedClassName}>{item.name}</span>
            )}
            {idx !== items.length - 1 && <ArrowRightSLineIcon size={20} />}
          </Fragment>
        );
      })}
    </p>
  );
};

export function SubProduct({ frontMatter, headings, html, productCategorySlug, description, faqs }: ProductPageProps) {
  const isUnderConstruction = !html.compiledSource.includes('h1');
 

  // const [showMobileNav, setShowMobileNav] = useState(false);
  const contentRef = useRef<HTMLDivElement>();
  // const [activeSection, setActiveSection] = useState('');
  const { FormRenderer } = useW3PurchaseFlow({
    productCategorySlug,
    purchaseFlowForms: [frontMatter],
  });


  const breadCrumbContent = [
    {
      name: unslugify(productCategorySlug),
      link: `/products/${productCategorySlug}`,
    },
    {
      name: unslugify(frontMatter.productTypeSlug),
    },
  ];

  // useEffect(() => {
  //   const handleScroll = () => {
  //     // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  //     const { top, bottom } = contentRef.current!.getBoundingClientRect();
  //     if (top < 0 && bottom > 0) {
  //       setShowMobileNav(true);
  //     } else {
  //       setShowMobileNav(false);
  //     }
  //   };
  //   !isUnderConstruction && window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // });

  return (
    <>
      <NextSeo title={unslugify(frontMatter.productTypeSlug) + '| PrishaPolicy'} description={description} />
      <ProductWriteUpContext.Provider value={{ frontMatter }}>
        <ProductMain color={productColorMapping[productCategorySlug]}>
          {/* <MobileHeadingsView headings={headings} activeSection={activeSection} showMobileNav={showMobileNav} /> */}
          <HeroBackground PurchaseFlowFormRenderer={FormRenderer} isUnderconstruction={isUnderConstruction}>
            <div className="mb-24 lg:mx-auto lg:w-1/2 lg:text-center">
              <div className="lg:hidden">
                <ProductBreadcrumbs items={breadCrumbContent} />
              </div>
              <h2 className="heading-2 my-3">{frontMatter.name || unslugify(frontMatter.productTypeSlug)}</h2>
              <p>{frontMatter.description}</p>
            </div>
          </HeroBackground>
          <div className="mt-10">
            {!isUnderConstruction ? (
              <div className="gap-x-15 container grid-cols-3  lg:grid">
                <div className="hidden lg:block">
                  <ProductBreadcrumbs items={breadCrumbContent} />
                  <div className="rounded-large border-grey-100 mt-7 border bg-white p-8">
                    <TableOfContents headings={headings} />
                    <CallbackForm />
                  </div>
                </div>
                <div className="prose prose-neutral col-span-2 mb-24 max-w-full">
                  <div ref={contentRef}>
                    <MDXRemote {...html} components={mdxElements} />
                  </div>
                </div>
              </div>
            ) : (
              <UnderConstruction />
            )}
          </div>
          <WhyChooseUs />
          <Faq list={faqs} />
        </ProductMain>
      </ProductWriteUpContext.Provider>
    </>
  );
}

export const getStaticProps = async ({ params }: { params: SubProductProps }) => {
  // read markdown file into content and frontmatter
  const productMarkdownContent = getParsedFileContentBySlug<ProductFrontMatter>(
    params.slug[1],
    join(PRODUCT_WRITEUPS_PATH, params.slug[0]),
  );

  // generate HTML
  const renderedHTML = await renderMarkdown(productMarkdownContent.content);
  const MarkdownComponent = <MDXRemote {...renderedHTML} components={mdxElements} />;
  const headings = getHeadings(renderToString(MarkdownComponent));
  const htmlString = renderToString(MarkdownComponent);

  const dom = new JSDOM(htmlString);
  const descriptionEl = dom.window.document.querySelector('p') as HTMLParagraphElement | null;
  const description = descriptionEl ? descriptionEl.textContent : params.slug[1] + ' Prisha Policy';

  return {
    props: {
      frontMatter: {
        ...productMarkdownContent.frontMatter,
        productTypeSlug: params.slug[1],
      },
      html: renderedHTML,
      productCategorySlug: params.slug[0],
      productTypeSlug: params.slug[1],
      headings,
      description,
      faqs: faqListMapping[params.slug[0].split('-')[0]],
    },
  };
};

export const getStaticPaths: GetStaticPaths<SubProductProps> = async () => {
  const paths = [];
  fs.readdirSync(PRODUCT_WRITEUPS_PATH).forEach((folder) => {
    fs.readdirSync(join(PRODUCT_WRITEUPS_PATH, folder)).forEach((file) => {
      paths.push({
        params: {
          slug: [folder, file.replace(/\.mdx?$/, '')],
        },
      });
    });
  });

  return {
    paths,
    fallback: false,
  };
};

export default SubProduct;
